import {IconButton, Tooltip, Typography} from "@mui/material";
import {InfoIcon} from "lucide-react";
import React from "react";
import {TooltipProps} from "@mui/material/Tooltip/Tooltip";

type Props = Pick<TooltipProps, 'placement'> & {
    children: React.ReactNode
}
export const MithraTooltip: React.FC<Props> = props => {
    let p = {...props};
    const children = p.children;
    if (children)
        delete p.children;
    return <Tooltip
        {...p}
        title={<Typography variant="caption">
            {children}
        </Typography>}>
        <IconButton>
            <InfoIcon/>
        </IconButton>
    </Tooltip>
}
